import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column flex-column-fluid" }
const _hoisted_2 = { class: "d-flex flex-column flex-column-fluid text-center p-10 py-lg-15" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  alt: "Logo",
  src: "/media/logos/logo-1.svg",
  class: "h-40px mb-5"
}, null, -1)
const _hoisted_4 = { class: "pt-lg-10 mb-10" }
const _hoisted_5 = { class: "fw-bolder fs-4x text-gray-800 mb-10" }
const _hoisted_6 = { class: "fw-bold fs-3 text-muted mb-15" }
const _hoisted_7 = { class: "text-center" }
const _hoisted_8 = { class: "d-flex flex-center flex-column-auto p-10" }
const _hoisted_9 = { class: "d-flex align-items-center fw-bold fs-6 d-none" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: "/dashboard",
        class: "mb-10 pt-lg-10"
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.$t('systemError')), 1),
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('somethingWrong')), 1),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_router_link, {
            to: "/",
            class: "btn btn-lg btn-primary fw-bolder"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('gotoHome')), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", {
        class: "d-flex flex-row-auto bgi-no-repeat bgi-position-x-center bgi-size-contain bgi-position-y-bottom min-h-100px min-h-lg-350px",
        style: _normalizeStyle({
          backgroundImage: 'url(' + _ctx.getIllustrationsPath('17.png') + ')',
        })
      }, null, 4)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("a", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (this.$router.push({ name: 'about' }))),
          class: "text-muted text-hover-primary px-2 cursor-pointer"
        }, _toDisplayString(_ctx.$t('aboutUs')), 1),
        _createElementVNode("a", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (this.$router.push({ name: 'contact' }))),
          class: "text-muted text-hover-primary px-2 cursor-pointer"
        }, _toDisplayString(_ctx.$t('contactUs')), 1)
      ])
    ])
  ]))
}